export const TOKEN = (import.meta.env.VITE_SIGNED_TOKEN as string) || 'busted';
